'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FileUpload } from '../common';
export const LogoUpload = ({ value, onChange, onRemoveFile, label = 'Upload File', width = 80, imageUrl }) => {
    const { t } = useTranslation();
    const handleFile = (file) => {
        onChange(file);
    };
    const handleFileRemove = (file) => {
        onRemoveFile && onRemoveFile(null);
    };
    return (_jsxs(Box, { display: 'flex', flexDirection: 'column', width: width, sx: { alignItems: 'center', justifyContent: 'center', gap: 2 }, children: [_jsx(Grid, { container: true, children: _jsx(FileUpload, { onChange: handleFile, allowedFileTypes: ['PNG', 'JPG', 'JPEG'], allowedFileTypesText: 'PNG, JPG, JPEG', allowedFileSize: 2, uploadLabel: t('UploadFile'), multiple: false, setVehicleDetails: () => { }, imageUrl: imageUrl, onFileRemove: handleFileRemove }) }), !value && (_jsx(Typography, { variant: 'caption', color: 'text.secondary', textAlign: 'center', children: label }))] }));
};
